import { PurchaseOrderDto, PurchaseOrderStatus, Roles, TeamRole, UserDto } from "app/api/models";

export class PurchaseOrderUtils {

    public static hasWriteAccessToPurchaseOrders = (user: UserDto) =>
        [TeamRole.Operations, TeamRole.Procurement].includes(user?.teamRole) || +user['role'] >= Roles.SuperAdmin;


    public static getStatusText(status: PurchaseOrderStatus) {
        if(status == null || status == undefined) return '';

        switch(status) {
            case PurchaseOrderStatus.PendingApproval: return 'Pending Approval';
            case PurchaseOrderStatus.InProduction: return 'In Production';
            case PurchaseOrderStatus.Picking: return 'Picking & Packing';
            case PurchaseOrderStatus.PartialReceived: return 'Partial Received';
            case PurchaseOrderStatus.AwaitingCustomerApproval: return 'Awaiting Customer';
            default: return (PurchaseOrderStatus[status]).toString();
        }
    }

    public static getStatusStyle(status: PurchaseOrderStatus) {
        var styleString = 'border-radius: 16px; padding: 2px 10px; width: min-content; white-space: pre; background-color: ';

        switch(status) {
            case PurchaseOrderStatus.Draft:
                return styleString + '#8f8f8f; color: white;'; // grey
            case PurchaseOrderStatus.Created:
                return styleString + '#ebe102 ;'; // Yellow
            case PurchaseOrderStatus.PendingApproval:
                return styleString + '#f1982f; color: white;'; // Orange
            case PurchaseOrderStatus.Rejected:
                return styleString + '#fb1d1d; color: white;'; // red
            case PurchaseOrderStatus.Approved:
                return styleString + '#82d300ff; color: white;'; // lime green

            case PurchaseOrderStatus.Ordered:
                return styleString + 'cornflowerblue; color: white;'; // Blue
            case PurchaseOrderStatus.Picking:
                return styleString + 'cornflowerblue; color: white;'; // Blue
            case PurchaseOrderStatus.InProduction:
                return styleString + 'cornflowerblue; color: white;'; // Blue

            case PurchaseOrderStatus.Dispatched:
                return styleString + '#00d308; color: white;'; // green
            case PurchaseOrderStatus.PartialReceived:
                return styleString + '#7f00d3ff; color: white;'; // purple
            case PurchaseOrderStatus.Received:
                return styleString + '#00d308; color: white;'; // purple
            case PurchaseOrderStatus.Complete:
                return styleString + '#019906ff; color: white;'; // darker green
            case PurchaseOrderStatus.AwaitingCustomerApproval:
                return styleString + '#f59e0b; color: white;'; // amber
            default:
                return '#f8f8f8;';
        }
    }

    public static getStatusColour(status: PurchaseOrderStatus) {
        switch(status) {
            case PurchaseOrderStatus.Draft: return '#8f8f8f';
            case PurchaseOrderStatus.Created: return '#ebe102';
            case PurchaseOrderStatus.PendingApproval: return '#f1982f';
            case PurchaseOrderStatus.Rejected: return '#fb1d1d';
            case PurchaseOrderStatus.Approved: return '#82d300ff';
            case PurchaseOrderStatus.Ordered: return'cornflowerblue';
            case PurchaseOrderStatus.Picking: return 'cornflowerblue';
            case PurchaseOrderStatus.InProduction: return 'cornflowerblue';
            case PurchaseOrderStatus.Dispatched: return '#00d308';
            case PurchaseOrderStatus.PartialReceived: return '#7f00d3ff';
            case PurchaseOrderStatus.Received: return '#00d308';
            case PurchaseOrderStatus.Complete: return '#019906ff';
            case PurchaseOrderStatus.AwaitingCustomerApproval: return '#f59e0b';
            default: return '#f8f8f8;';
        }
    }
}
